const COLLECTIONS = ["sei1gu3lzz75ttmnwjua7meachry4x3avfdhjv0t9jlz8xvnxweh7ersc7l78r", "sei1v90ly54qeu7497lzk2mnmp2h29sgtep8hs5ryvfqf8dwq5gc0t9srp6aey", "sei1pkteljh83a83gmazcvam474f7dwt9wzcyqcf5puxvqqs6jcx8nnq2y74lu", "sei1vjgrptlrm0alx330lv6260kzewv7p8elpputvedd45sxrtel2v5qzkrcd7"]
const MARKETPLACE = "sei1u3un7z8cle4z905s53xqfaalj5ze9emmw62wvpc6jhmgsuvw6eds4ajfgx"
const PALLET_MARKETPLACE = "sei152u2u0lqc27428cuf8dx48k8saua74m6nql5kgvsu4rfeqm547rsnhy4y9"
const DECIMAL = 1000000
const LISTING_PAGE_COUNT = 22

module.exports = {
    COLLECTIONS,
    MARKETPLACE,
    PALLET_MARKETPLACE,
    DECIMAL,
    LISTING_PAGE_COUNT
}